module.exports = __webpack_public_path__ + "img/A10.709373b7.jpg";